let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4pLuY")).then(() => parcelRequire('7NfSm'));